(function ($) {
    var CookieBar = function () {
        this.elAppWrapper = $('#cookie-wrapper');

        this.elBar = $('#cookie-bar');
        this.elBarBg = $('#cookie-bar-bg');
        this.elShowSettingsBtn = $('.cookie-bar-settings-button');

        this.elSettingsBg = $('#cookie-settings-bg');
        this.elSettings = $('#cookie-settings');
        this.elSettingsContainer = $('.cookie-settings-popup-container');

        this.elCheckbox = $('.cookie-settings-toggle-switch-input');

        this.elAllowAllBtn = $('.cookie-btn-allow-all');
        this.elSetSettingsBtn = $('.cookie-btn-set-settings');
        this.elDeclineAllBtn = $('.cookie-btn-decline-all-inner-link');

        this.elSettingsChoice = $('.cookie-settings-choice');
        this.elSettingsText = $('.cookie-settings-type-text');
        this.elShowMoreBtn = $('.show-more');
        this.elShowLessBtn = $('.show-less');
        this.elCloseBtn = $('.cookie-setting-close');

        this.elOpenSettingsLink = $('.cookie-link-open-settings');

        this.elAnalyticalCookiesAllowed = $('#analyticalCookiesAllowed');
        this.elPersonalizedCookiesAllowed = $('#personalizedCookiesAllowed');
        this.elMarketingCookiesAllowed = $('#marketingCookiesAllowed');
    };

    CookieBar.prototype.init = function () {
        var self = this;

        self.initOpenSettingsLink();

        $(self.elBar).find(self.elShowSettingsBtn).off('click').on('click', function () {
            self.openSettings();
        });

        $(self.elAppWrapper).find(self.elAllowAllBtn).off('click').on('click', function () {
            self.closeBar();
            self.elCheckbox.prop('checked', true);
            $.nette.ajax({
                url: $(this).data('link'),//.replace('--category--', )
            }).error(function () {
                alert('CookieBar ajax not working.');
            });
        });

        $(self.elSettings).find(self.elSetSettingsBtn).off('click').on('click', function (e) {
            var settings = [];

            if ($(self.elAnalyticalCookiesAllowed).length && $(self.elAnalyticalCookiesAllowed).prop('checked')) {
                settings['analyticsCookiesEnabled'] = 1;
            }
            if ($(self.elPersonalizedCookiesAllowed).length && $(self.elPersonalizedCookiesAllowed).prop('checked')) {
                settings['personalisationCookiesEnabled'] = 1;
            }
            if ($(self.elMarketingCookiesAllowed).length && $(self.elMarketingCookiesAllowed).prop('checked')) {
                settings['marketingCookiesEnabled'] = 1;
            }

            var query = self.arrayToParams(settings);

            self.closeBar();
            $.nette.ajax({
                url: $(this).closest(self.elSetSettingsBtn).data('link') + (query.length ? '&' + query : ''),
            }).error(function () {
                alert('CookieBar ajax not working.');
            });
        });

        $(self.elBar).find(self.elDeclineAllBtn).find('a').off('click').on('click', function (e) {
            e.preventDefault();
            self.closeBar();
            self.elCheckbox.prop('checked', false);
            $.nette.ajax({
                url: $(this).closest(self.elDeclineAllBtn).data('link'),//.replace('--category--', )
            }).error(function () {
                alert('CookieBar ajax not working.');
            });
        });

        $(self.elSettings).find(self.elShowMoreBtn).off('click').on('click', function (e) {
            $(this).closest(self.elSettingsChoice).find(self.elSettingsText).css('max-height', '1000px');
            setTimeout(function () {
                $(this).closest(self.elSettingsChoice).find(self.elSettingsText).css('max-height', 'initial');
            }, 1000);
            // $(this).closest(self.elSettingsChoice).find(self.elSettingsText).removeClass('cookie-settings-limited');
            $(this).closest(self.elSettingsChoice).find(self.elShowLessBtn).removeClass('hide');
            $(this).addClass('hide');
        });

        $(self.elSettings).find(self.elShowLessBtn).off('click').on('click', function (e) {
            $(this).closest(self.elSettingsChoice).find(self.elSettingsText).css('max-height', '40px');
            // $(this).closest(self.elSettingsChoice).find(self.elSettingsText).addClass('cookie-settings-limited');
            $(this).closest(self.elSettingsChoice).find(self.elShowMoreBtn).removeClass('hide');
            $(this).addClass('hide');
        });
    };

    CookieBar.prototype.arrayToParams = function (object) {
        var parameters = [];
        for (var property in object) {
            if (object.hasOwnProperty(property)) {
                parameters.push(encodeURI(property + '=' + object[property]));
            }
        }

        return parameters.join('&');
    }

    CookieBar.prototype.closeBar = function () {
        $(this.elBar).css('display', 'none');
        if ($(this.elBarBg).length) {
            $(this.elBarBg).css('display', 'none');
        }
        this.closeSettings();
    }

    CookieBar.prototype.openSettings = function () {
        var self = this;

        self.showSettings();

        $(self.elCloseBtn).off('click').on('click', function () {
            self.closeSettings();
        });

        $(self.elSettingsBg).off('click').on('click', function (e) {
            self.closeSettings();
        });
        $(self.elSettings).off('click').on('click', function (e) {
            if ($(e.target).attr('id') === self.elSettings.attr('id')) {
                self.closeSettings();
            }
        });
    }

    CookieBar.prototype.showSettings = function () {
        $(this.elSettingsBg).css('display', 'flex');
        $(this.elSettings).css('display', 'flex');
        window.scrollTo(0, 0);
    }

    CookieBar.prototype.closeSettings = function () {
        $(this.elSettingsBg).css('display', 'none');
        $(this.elSettings).css('display', 'none');
    }

    CookieBar.prototype.initOpenSettingsLink = function () {
        var self = this;

        $(self.elOpenSettingsLink).off('click').on('click', function (e) {
            e.preventDefault();
            self.openSettings();
        });
    }


    $(document).ready(function () {
        window.cookieBar = new CookieBar();

        if ($(window.cookieBar.elOpenSettingsLink).length || $(window.cookieBar.elBar).length) {
            window.cookieBar.init();
        }
    });
})(jQuery);